export type WorldCityRegion =
  | 'Europe'
  | 'Afrique'
  | 'Moyen-Orient'
  | 'Asie'
  | 'Amérique du Nord'
  | 'Amérique du Sud'
  | 'Océanie';

export type WorldCity = {
  /** Nom affiché (français). */
  name: string;
  country: string;
  /** Fuseau IANA associé — présélectionné quand la ville est choisie. */
  timezone: string;
  region: WorldCityRegion;
};

export const WORLD_CITY_REGIONS: WorldCityRegion[] = [
  'Europe',
  'Afrique',
  'Moyen-Orient',
  'Asie',
  'Amérique du Nord',
  'Amérique du Sud',
  'Océanie',
];

export const WORLD_CITIES: WorldCity[] = [
  // Europe
  { name: 'Paris', country: 'France', timezone: 'Europe/Paris', region: 'Europe' },
  { name: 'Lyon', country: 'France', timezone: 'Europe/Paris', region: 'Europe' },
  { name: 'Marseille', country: 'France', timezone: 'Europe/Paris', region: 'Europe' },
  { name: 'Bruxelles', country: 'Belgique', timezone: 'Europe/Brussels', region: 'Europe' },
  { name: 'Genève', country: 'Suisse', timezone: 'Europe/Zurich', region: 'Europe' },
  { name: 'Zurich', country: 'Suisse', timezone: 'Europe/Zurich', region: 'Europe' },
  { name: 'Luxembourg', country: 'Luxembourg', timezone: 'Europe/Luxembourg', region: 'Europe' },
  { name: 'Amsterdam', country: 'Pays-Bas', timezone: 'Europe/Amsterdam', region: 'Europe' },
  { name: 'Londres', country: 'Royaume-Uni', timezone: 'Europe/London', region: 'Europe' },
  { name: 'Dublin', country: 'Irlande', timezone: 'Europe/Dublin', region: 'Europe' },
  { name: 'Lisbonne', country: 'Portugal', timezone: 'Europe/Lisbon', region: 'Europe' },
  { name: 'Madrid', country: 'Espagne', timezone: 'Europe/Madrid', region: 'Europe' },
  { name: 'Barcelone', country: 'Espagne', timezone: 'Europe/Madrid', region: 'Europe' },
  { name: 'Rome', country: 'Italie', timezone: 'Europe/Rome', region: 'Europe' },
  { name: 'Milan', country: 'Italie', timezone: 'Europe/Rome', region: 'Europe' },
  { name: 'Berlin', country: 'Allemagne', timezone: 'Europe/Berlin', region: 'Europe' },
  { name: 'Munich', country: 'Allemagne', timezone: 'Europe/Berlin', region: 'Europe' },
  { name: 'Francfort', country: 'Allemagne', timezone: 'Europe/Berlin', region: 'Europe' },
  { name: 'Vienne', country: 'Autriche', timezone: 'Europe/Vienna', region: 'Europe' },
  { name: 'Prague', country: 'Tchéquie', timezone: 'Europe/Prague', region: 'Europe' },
  { name: 'Varsovie', country: 'Pologne', timezone: 'Europe/Warsaw', region: 'Europe' },
  { name: 'Stockholm', country: 'Suède', timezone: 'Europe/Stockholm', region: 'Europe' },
  { name: 'Oslo', country: 'Norvège', timezone: 'Europe/Oslo', region: 'Europe' },
  { name: 'Copenhague', country: 'Danemark', timezone: 'Europe/Copenhagen', region: 'Europe' },
  { name: 'Helsinki', country: 'Finlande', timezone: 'Europe/Helsinki', region: 'Europe' },
  { name: 'Athènes', country: 'Grèce', timezone: 'Europe/Athens', region: 'Europe' },
  { name: 'Bucarest', country: 'Roumanie', timezone: 'Europe/Bucharest', region: 'Europe' },
  { name: 'Istanbul', country: 'Turquie', timezone: 'Europe/Istanbul', region: 'Europe' },

  // Afrique
  { name: 'Casablanca', country: 'Maroc', timezone: 'Africa/Casablanca', region: 'Afrique' },
  { name: 'Rabat', country: 'Maroc', timezone: 'Africa/Casablanca', region: 'Afrique' },
  { name: 'Alger', country: 'Algérie', timezone: 'Africa/Algiers', region: 'Afrique' },
  { name: 'Tunis', country: 'Tunisie', timezone: 'Africa/Tunis', region: 'Afrique' },
  { name: 'Le Caire', country: 'Égypte', timezone: 'Africa/Cairo', region: 'Afrique' },
  { name: 'Dakar', country: 'Sénégal', timezone: 'Africa/Dakar', region: 'Afrique' },
  { name: 'Abidjan', country: "Côte d'Ivoire", timezone: 'Africa/Abidjan', region: 'Afrique' },
  { name: 'Accra', country: 'Ghana', timezone: 'Africa/Accra', region: 'Afrique' },
  { name: 'Lagos', country: 'Nigeria', timezone: 'Africa/Lagos', region: 'Afrique' },
  { name: 'Douala', country: 'Cameroun', timezone: 'Africa/Douala', region: 'Afrique' },
  { name: 'Kinshasa', country: 'RD Congo', timezone: 'Africa/Kinshasa', region: 'Afrique' },
  { name: 'Nairobi', country: 'Kenya', timezone: 'Africa/Nairobi', region: 'Afrique' },
  { name: 'Addis-Abeba', country: 'Éthiopie', timezone: 'Africa/Addis_Ababa', region: 'Afrique' },
  { name: 'Johannesburg', country: 'Afrique du Sud', timezone: 'Africa/Johannesburg', region: 'Afrique' },
  { name: 'Le Cap', country: 'Afrique du Sud', timezone: 'Africa/Johannesburg', region: 'Afrique' },
  { name: 'Antananarivo', country: 'Madagascar', timezone: 'Indian/Antananarivo', region: 'Afrique' },
  { name: 'Port-Louis', country: 'Maurice', timezone: 'Indian/Mauritius', region: 'Afrique' },

  // Moyen-Orient
  { name: 'Dubaï', country: 'Émirats arabes unis', timezone: 'Asia/Dubai', region: 'Moyen-Orient' },
  { name: 'Abou Dabi', country: 'Émirats arabes unis', timezone: 'Asia/Dubai', region: 'Moyen-Orient' },
  { name: 'Doha', country: 'Qatar', timezone: 'Asia/Qatar', region: 'Moyen-Orient' },
  { name: 'Riyad', country: 'Arabie saoudite', timezone: 'Asia/Riyadh', region: 'Moyen-Orient' },
  { name: 'Tel-Aviv', country: 'Israël', timezone: 'Asia/Jerusalem', region: 'Moyen-Orient' },
  { name: 'Beyrouth', country: 'Liban', timezone: 'Asia/Beirut', region: 'Moyen-Orient' },

  // Asie
  { name: 'Mumbai', country: 'Inde', timezone: 'Asia/Kolkata', region: 'Asie' },
  { name: 'New Delhi', country: 'Inde', timezone: 'Asia/Kolkata', region: 'Asie' },
  { name: 'Bangalore', country: 'Inde', timezone: 'Asia/Kolkata', region: 'Asie' },
  { name: 'Karachi', country: 'Pakistan', timezone: 'Asia/Karachi', region: 'Asie' },
  { name: 'Dacca', country: 'Bangladesh', timezone: 'Asia/Dhaka', region: 'Asie' },
  { name: 'Bangkok', country: 'Thaïlande', timezone: 'Asia/Bangkok', region: 'Asie' },
  { name: 'Hanoï', country: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh', region: 'Asie' },
  { name: 'Hô Chi Minh-Ville', country: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh', region: 'Asie' },
  { name: 'Singapour', country: 'Singapour', timezone: 'Asia/Singapore', region: 'Asie' },
  { name: 'Kuala Lumpur', country: 'Malaisie', timezone: 'Asia/Kuala_Lumpur', region: 'Asie' },
  { name: 'Jakarta', country: 'Indonésie', timezone: 'Asia/Jakarta', region: 'Asie' },
  { name: 'Manille', country: 'Philippines', timezone: 'Asia/Manila', region: 'Asie' },
  { name: 'Hong Kong', country: 'Hong Kong', timezone: 'Asia/Hong_Kong', region: 'Asie' },
  { name: 'Shanghai', country: 'Chine', timezone: 'Asia/Shanghai', region: 'Asie' },
  { name: 'Pékin', country: 'Chine', timezone: 'Asia/Shanghai', region: 'Asie' },
  { name: 'Taipei', country: 'Taïwan', timezone: 'Asia/Taipei', region: 'Asie' },
  { name: 'Séoul', country: 'Corée du Sud', timezone: 'Asia/Seoul', region: 'Asie' },
  { name: 'Tokyo', country: 'Japon', timezone: 'Asia/Tokyo', region: 'Asie' },
  { name: 'Osaka', country: 'Japon', timezone: 'Asia/Tokyo', region: 'Asie' },

  // Amérique du Nord
  { name: 'Montréal', country: 'Canada', timezone: 'America/Montreal', region: 'Amérique du Nord' },
  { name: 'Toronto', country: 'Canada', timezone: 'America/Toronto', region: 'Amérique du Nord' },
  { name: 'Vancouver', country: 'Canada', timezone: 'America/Vancouver', region: 'Amérique du Nord' },
  { name: 'New York', country: 'États-Unis', timezone: 'America/New_York', region: 'Amérique du Nord' },
  { name: 'Washington', country: 'États-Unis', timezone: 'America/New_York', region: 'Amérique du Nord' },
  { name: 'Boston', country: 'États-Unis', timezone: 'America/New_York', region: 'Amérique du Nord' },
  { name: 'Miami', country: 'États-Unis', timezone: 'America/New_York', region: 'Amérique du Nord' },
  { name: 'Chicago', country: 'États-Unis', timezone: 'America/Chicago', region: 'Amérique du Nord' },
  { name: 'Dallas', country: 'États-Unis', timezone: 'America/Chicago', region: 'Amérique du Nord' },
  { name: 'Houston', country: 'États-Unis', timezone: 'America/Chicago', region: 'Amérique du Nord' },
  { name: 'Denver', country: 'États-Unis', timezone: 'America/Denver', region: 'Amérique du Nord' },
  { name: 'Phoenix', country: 'États-Unis', timezone: 'America/Phoenix', region: 'Amérique du Nord' },
  { name: 'Los Angeles', country: 'États-Unis', timezone: 'America/Los_Angeles', region: 'Amérique du Nord' },
  { name: 'San Francisco', country: 'États-Unis', timezone: 'America/Los_Angeles', region: 'Amérique du Nord' },
  { name: 'Seattle', country: 'États-Unis', timezone: 'America/Los_Angeles', region: 'Amérique du Nord' },
  { name: 'Mexico', country: 'Mexique', timezone: 'America/Mexico_City', region: 'Amérique du Nord' },

  // Amérique du Sud
  { name: 'Bogota', country: 'Colombie', timezone: 'America/Bogota', region: 'Amérique du Sud' },
  { name: 'Lima', country: 'Pérou', timezone: 'America/Lima', region: 'Amérique du Sud' },
  { name: 'Quito', country: 'Équateur', timezone: 'America/Guayaquil', region: 'Amérique du Sud' },
  { name: 'Caracas', country: 'Venezuela', timezone: 'America/Caracas', region: 'Amérique du Sud' },
  { name: 'Santiago', country: 'Chili', timezone: 'America/Santiago', region: 'Amérique du Sud' },
  { name: 'Buenos Aires', country: 'Argentine', timezone: 'America/Argentina/Buenos_Aires', region: 'Amérique du Sud' },
  { name: 'Montevideo', country: 'Uruguay', timezone: 'America/Montevideo', region: 'Amérique du Sud' },
  { name: 'São Paulo', country: 'Brésil', timezone: 'America/Sao_Paulo', region: 'Amérique du Sud' },
  { name: 'Rio de Janeiro', country: 'Brésil', timezone: 'America/Sao_Paulo', region: 'Amérique du Sud' },
  { name: 'Brasilia', country: 'Brésil', timezone: 'America/Sao_Paulo', region: 'Amérique du Sud' },

  // Océanie
  { name: 'Sydney', country: 'Australie', timezone: 'Australia/Sydney', region: 'Océanie' },
  { name: 'Melbourne', country: 'Australie', timezone: 'Australia/Melbourne', region: 'Océanie' },
  { name: 'Brisbane', country: 'Australie', timezone: 'Australia/Brisbane', region: 'Océanie' },
  { name: 'Perth', country: 'Australie', timezone: 'Australia/Perth', region: 'Océanie' },
  { name: 'Auckland', country: 'Nouvelle-Zélande', timezone: 'Pacific/Auckland', region: 'Océanie' },
];

const normalize = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const findWorldCity = (name: string | null | undefined): WorldCity | undefined => {
  if (!name) return undefined;
  const needle = normalize(name.trim());
  return WORLD_CITIES.find((city) => normalize(city.name) === needle);
};

export const searchWorldCities = (query: string, limit = 30): WorldCity[] => {
  const needle = normalize(query.trim());
  if (!needle) return WORLD_CITIES.slice(0, limit);
  return WORLD_CITIES.filter(
    (city) => normalize(city.name).includes(needle) || normalize(city.country).includes(needle)
  ).slice(0, limit);
};

/** Offset GMT dynamique (gère l'heure d'été), ex. "GMT+2", "GMT-4", "GMT+5:30". */
export const gmtOffsetLabel = (timezone: string, at: Date = new Date()): string => {
  try {
    const formatter = new Intl.DateTimeFormat('fr-FR', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    });
    const raw = formatter.formatToParts(at).find((part) => part.type === 'timeZoneName')?.value ?? '';
    if (!raw) return '';
    if (raw === 'UTC' || raw === 'GMT') return 'GMT+0';
    return raw.replace('UTC', 'GMT');
  } catch {
    return '';
  }
};

/** Offset court pour badges, ex. "+2", "-4", "+5:30", "0". */
export const gmtOffsetBadge = (timezone: string, at: Date = new Date()): string => {
  const label = gmtOffsetLabel(timezone, at);
  const match = label.match(/([+-]\d+(?::\d+)?)/);
  if (match) return match[1];
  return label ? '0' : '?';
};
